import { useEffect, useState } from "react";
import Api from "../../../../services/Api";
import BarGraph from "../../../general/BarGraph";
import Functions from "../../../../services/Functions";
import styles from "./FabricadosL1.module.css";

function FabricadosL1({ distrito }) {
  const [produtosFabricados, setProdutosFabricados] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [produtosFabricados] = await Promise.all([
          Api.getProdutosFabricados(distrito),
        ]);
        setProdutosFabricados(Functions.buildBarGraph(produtosFabricados));
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [distrito]);

  const mockupFunction = (value) => {
    value = value + 1;
  };

  return (
    <div className={styles.fabricadosL1}>
      <div className={styles.smallPiegraph}>
        {produtosFabricados && (
          <BarGraph
            data={produtosFabricados}
            text="NÚMERO DE PROPRIEDADES FABRICANTES DE PRODUTOS"
            onLegendClick={mockupFunction}
            currentValue={null}
            oldValue={null}
            onOldValue={mockupFunction}
            onImageReady={mockupFunction}
          />
        )}
      </div>
    </div>
  );
}

export default FabricadosL1;
